import React from "react";
import { Button } from "@yoast/ui-library";

import * as styles from "./styles.module.scss";
import classnames from "classnames";

export const IconButton = ( props ) => {
	const { className, children, ...otherProps } = props;

	return (
		<Button
			className={ classnames( styles.iconButton, className ) }
			{ ...otherProps }
		>
			{ children }
		</Button>
	);
};
